export interface Coupon {
    wooId?: number;
    code: string;
    amount?: number;
    description?: string;
    isExpired?: boolean;
    isUsed?: boolean;
}
